import { Omit } from '@40seas/entities/common';
import { RefundReconciliation } from './refund.reconciliation.entity';

export class RefundReconciliationQueryDto extends Omit(RefundReconciliation, ['buyerLegalName', 'revenue', 'id']) {}
